import { useContext } from 'react';

import { PipelineContext } from '../context/PipelineProvider';

export function usePipeline() {
  const context = useContext(PipelineContext);

  if (context === undefined) {
    throw new Error('usePipeline must be used within a PipelineProvider');
  }

  return context;
}
